import React from 'react';
import { Button, Flex } from '@/components/ui';
import { useUploadQueue } from '@/contexts/UploadQueueContext';
import { getErrorFiles } from '@/utils/uploadQueueUtils';

import {
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerStop,
  IconRefresh,
  IconTrash,
} from '@tabler/icons-react';

const UploadQueueControls: React.FC = () => {
  const {
    state,
    startUpload,
    pauseUpload,
    cancelUpload,
    clearQueue,
    retryAllErrors,
    getStats,
  } = useUploadQueue();

  const stats = getStats();
  const errorFiles = getErrorFiles(state.files);
  const hasPendingFiles = stats.pending > 0;
  const hasErrorFiles = errorFiles.length > 0;

  return (
    <Flex gap="2" wrap="nowrap">
      {/* Start/Pause Upload */}
      {!state.isUploading && !state.isPaused && hasPendingFiles && (
        <Button
          size="small"
          variant="classic"
          color="success"
          onClick={startUpload}
          style={{ flex: '1', width: '100%' }}
          className="upload-queue-widget__start-upload-button"
          startIcon={<IconPlayerPlay />}
        >
          Start Upload
        </Button>
      )}

      {state.isUploading && (
        <>
          <Button
            size="small"
            variant="surface"
            color="default"
            onClick={pauseUpload}
            style={{ flex: '1' }}
            startIcon={<IconPlayerPause />}
          >
            Pause
          </Button>
          <Button
            size="small"
            variant="surface"
            color="default"
            onClick={cancelUpload}
            style={{ flex: '1' }}
            startIcon={<IconPlayerStop />}
          >
            Stop
          </Button>
        </>
      )}

      {state.isPaused && hasPendingFiles && (
        <>
          <Button
            size="small"
            variant="surface"
            color="default"
            onClick={startUpload}
            style={{ flex: '1' }}
            startIcon={<IconPlayerPlay />}
          >
            Resume
          </Button>
          <Button
            size="small"
            variant="surface"
            color="default"
            onClick={cancelUpload}
            style={{ flex: '1' }}
            startIcon={<IconPlayerStop />}
          >
            Stop
          </Button>
        </>
      )}

      {/* Secondary Actions */}
      {!state.isUploading && (
        <>
          {/* Retry Errors */}
          {hasErrorFiles && (
            <Button
              size="small"
              variant="surface"
              color="default"
              startIcon={<IconRefresh />}
              onClick={() => {
                retryAllErrors();
                startUpload();
              }}
            >
              Retry Failed
            </Button>
          )}

          {/* Clear Queue */}
          {stats.total > 0 && (
            <Button
              size="small"
              variant="surface"
              color="default"
              startIcon={<IconTrash />}
              onClick={clearQueue}
            >
              Clear All
            </Button>
          )}
        </>
      )}
    </Flex>
  );
};

export default UploadQueueControls;
